var _title;
var _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
var SvgImageOutline = function SvgImageOutline(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    ref: svgRef
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "ionicons-v5-e")), /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 115,
    width: 416,
    height: 320,
    rx: 48,
    ry: 48,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 16
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 210,
    r: 20,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 16
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320,335.79,213.34,245.3A32,32,0,0,0,169.47,244L48,352",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 16
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224,432,347.34,308.66a32,32,0,0,1,43.11-2L464,368",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 16
    }
  }));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgImageOutline, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/image-outline.a7fa0db0.svg";
export { ForwardRef as ReactComponent };